import { theme } from "@project/shared/src/theme";
import { styled } from "linaria/lib/react";
import ArrowIcon from "../../../assets/double-arrow.svg";
const Wrapper = /*#__PURE__*/styled("section")({
  name: "Wrapper",
  class: "wp7oivx"
});
const Container = /*#__PURE__*/styled("div")({
  name: "Container",
  class: "c1h7cpcr"
});
const TitleSection = /*#__PURE__*/styled("div")({
  name: "TitleSection",
  class: "tl0icv8"
});
const Section = /*#__PURE__*/styled("div")({
  name: "Section",
  class: "s11us7x1"
});
const StepsGroup = /*#__PURE__*/styled("div")({
  name: "StepsGroup",
  class: "su39l0l"
});
const Step = /*#__PURE__*/styled("div")({
  name: "Step",
  class: "smzr1j9"
});
const StepArrow = /*#__PURE__*/styled("div")({
  name: "StepArrow",
  class: "scsyivu"
});
const StepGroup = /*#__PURE__*/styled("div")({
  name: "StepGroup",
  class: "s1wyd26s"
});
const PointsGroup = /*#__PURE__*/styled("div")({
  name: "PointsGroup",
  class: "pkjwgur"
});
const Points = /*#__PURE__*/styled("div")({
  name: "Points",
  class: "p1ds7ciy"
});
const Divider = /*#__PURE__*/styled("div")({
  name: "Divider",
  class: "d1d9oe5n"
});
const ColoredBlock = /*#__PURE__*/styled("span")({
  name: "ColoredBlock",
  class: "c869zln",
  vars: {
    "c869zln-0": [props => props.isBlue ? theme.blue6 : theme.orangeDark]
  }
});

const ContactFlowToUse = () => {
  return <Wrapper>
      <div>
        <Container>
          <TitleSection>
            <h3>ご利用の流れ</h3>
            <p>コワーケーション.coｍご利用の流れをご説明します。</p>
          </TitleSection>
          <Section>
            <StepsGroup>
              {[{
              step: 1,
              title: "施設・コンテンツ登録",
              description: "施設やコンテンツの基本情報、写真、施設のアピールポイント等の情報を掲載。法人利用に特化した情報が予め集約されているため、施設の魅力を最大化可能。"
            }, {
              step: 2,
              title: "企画提案",
              description: "法人・団体からの企画相談内容に合わせて、弊社コンシェルジュと相談しながら、利用社に対する滞在中の企画を提案。（ビッド方式を採用）"
            }, {
              step: 3,
              title: "受注確定",
              description: "受注確定後は、発注者と直接プラットフォーム上でコミュニケーションをとり、滞在中のリクエスト等詳細のプランをやりとり。すべてのやりとりはプラットフォーム上で一元管理可能。"
            }, {
              step: 4,
              title: "利用・精算",
              description: "発注者のご利用実施後、精算。滞在中のレビューを受信し、次なる顧客ニーズに対応する学び、サービス改善に活用可能。"
            }].map((item, index) => {
              return <>
                    <Step key={`setp_${index}`}>
                      <StepGroup>
                        <img src={`/flow_to_use/${item.step}.svg`} alt={`Flow to use Step ${item.step}`} loading="eager" />
                        <h4>STEP {item.step}</h4>
                        <h3>{item.title}</h3>
                        <p>{item.description}</p>
                      </StepGroup>
                    </Step>
                    {index < 3 && <StepArrow>
                        <ArrowIcon className="arrow" />
                      </StepArrow>}
                  </>;
            })}
            </StepsGroup>
          </Section>
          <Section>
            <PointsGroup>
              {[{
              point: "POINT 1",
              title: "登録料・掲載料",
              description: ["施設・コンテンツの紹介ページを作成します。登録料・掲載料として登録時に¥50,000（税別）をいただきます"]
            }, {
              point: "POINT 2",
              title: "予約確定まで負担なし",
              description: "予約確定後手数料一律 10%",
              list: ["※優先事業主様には2年間総受注額の10％負担（変更手数料不要）"]
            }, {
              point: "POINT 3",
              title: "キャンセルリスクの軽減",
              description: "実施前に利用者からデポジット受取・キャンセルリスクを軽減"
            }].map((item, index) => {
              return <Points key={`points_${index}`}>
                    <h4>
                      <ColoredBlock>{item.point}</ColoredBlock> <Divider />
                      {item.title}
                    </h4>
                    {typeof item.description == "object" ? item.description?.map((desc, idx) => {
                  return <p key={`description_${idx}`}>{desc}</p>;
                }) : <p>{item.description}</p>}
                    {item.list && <ul>
                        {item.list.map((list, idx) => {
                    return <li key={`list_${idx}`}>{list}</li>;
                  })}
                      </ul>}
                  </Points>;
            })}
            </PointsGroup>
          </Section>
        </Container>
      </div>
    </Wrapper>;
};

export { ContactFlowToUse };

require("./index.linaria.module.css!=!../../../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./index.tsx");